module.exports = __webpack_public_path__ + "img/card.783e8015.png";